import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      date: this.minDate,
      time: null,
      modal_date: false,
      modal_time: false,
      date_picker: 0,
      sheet: false,
    };
  },
  mounted() {
    moment.locale("it");
  },
  watch: {
    tot_cc: function () {
      this.date = "";
      this.time = null;
    },
    date: function () {
      this.time = null;
    },
  },
  computed: {
    ...mapGetters({
      soglie: "get_soglie_orari",
    }),
    dateFormatter() {
      return this.date ? moment(this.date).format("ddd D MMM") : "";
    },
    minuti_soglia() {
      return this.tot_cc * this.soglie.t_prep_cc;
    },
    minDate() {
      const currentMoment = moment();
      const minutiSogliaMoment = currentMoment.clone().add(this.minuti_soglia, "minutes");
      const chiusuraMoment = currentMoment.clone().hour(this.soglie.chiusura);
    
      if (minutiSogliaMoment.isAfter(chiusuraMoment)) {
        return currentMoment.clone().add(1, "day").format("YYYY-MM-DD");
      } else {
        return currentMoment.format("YYYY-MM-DD");
      }
    },
    maxDate() {
      return moment().add(7, "days").format("YYYY-MM-DD");
    },

    minHour() {
      const currentMoment = moment();
      const selectedDate = moment(this.date);
    
      if (selectedDate.isSame(currentMoment, "day")) {
        return currentMoment.clone().add(this.minuti_soglia, "minutes").format("HH");
      }
    
      if (selectedDate.isSame(currentMoment.clone().add(1, "day"), "day")) {
        const chiusuraMoment = currentMoment.clone().hour(this.soglie.chiusura);
        const t_left = this.minuti_soglia - moment.duration(chiusuraMoment.diff(currentMoment)).asMinutes();
        return currentMoment.clone().add(1, "day").hour(this.soglie.apertura).add(t_left, "minutes").format("HH");
      }
    
      if (selectedDate.isAfter(currentMoment.clone().add(1, "day"))) {
        return this.soglie.apertura.toString();
      }
    
      // Default case if none of the above conditions are met
      return this.soglie.apertura.toString();
    },
    prima_data() {
      const currentMoment = moment();
      const minutiSogliaMoment = currentMoment
        .clone()
        .add(this.minuti_soglia, "minutes");
      const chiusuraMoment = currentMoment.clone().hour(this.soglie.chiusura);
      //const aperturaMoment = currentMoment.clone().hour(this.soglie.apertura);

      let giorno;
      let ora;

      if (minutiSogliaMoment.isAfter(chiusuraMoment)) {
        giorno = currentMoment.clone().add(1, "day");
        const t_left =
          this.minuti_soglia -
          moment.duration(chiusuraMoment.diff(currentMoment)).asMinutes();
        ora = giorno.clone().hour(this.soglie.apertura).add(t_left, "minutes");
      } else {
        giorno = currentMoment.clone();
        ora = minutiSogliaMoment;
        if (currentMoment.isSame(ora, "hour")) {
          ora.add(1, "hour");
        }
      }

      if (giorno.isoWeekday() === 7) {
        giorno.add(1, "day");
      }

      const formattedOra =
        ora.format("HH") !== "13"
          ? ora.format("HH")
          : ora.add(1, "hour").format("HH");

      return {
        giorno: giorno.format("dddd DD MMMM"),
        ora: formattedOra,
        formatted: giorno.format("YYYY-MM-DD"),
      };
    },
    valid_day() {
      return !(this.date != null && this.date != "");
    },
  },
  methods: {
    allowedDate: (d) => parseInt(moment(d).isoWeekday()) != 7,
    closePiker: function (v) {
      v = v < 10 ? "0" + v : v;
      this.time = v + ":00";
      this.modal_time = false;
    },
    set_prima_data() {
      this.date = this.prima_data.formatted;
      setTimeout(() => {
        this.time = this.prima_data.ora + ":00";
      }, 100);
    },
  },
};
